<template>
  <div>
    <v-container>
      <v-row no-gutters>
        <v-col cols="12">
          <div class="cs-form-intro-large pt-6 pb-4">
            {{ $t('history.title') }}
          </div>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <template>
          <v-card>
            <v-card-title>
              <v-text-field v-model="search" append-icon="search" :label="this.$t('history.csHistory.search')"
                single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="history" :search="search"></v-data-table>
          </v-card>
        </template>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  data() {
    return {
      history: [],

      isLoading: false,
      error: null,
      isDelayElapsed: false,

      search: '',

      insuranceCompanies: [],
    };
  },
  computed: {
    headers: function () {
      return [
        {
          text: this.$t('history.csHistory.columnHeaders.date'),
          value: 'createdOnFormatted',
        },
        {
          text: this.$t('history.csHistory.columnHeaders.plateNbr'),
          value: 'plateNumber',
        },
        {
          text: this.$t('history.csHistory.columnHeaders.contractNbr'),
          value: 'contractNumber',
        },
        {
          text: this.$t('history.csHistory.columnHeaders.insuranceCompany'),
          value: 'insuranceCompany',
        },
      ];
    },
  },
  created: function () {
    this.error = null;
    this.isLoading = true;
    this.isDelayElapsed = false;

    const insuranceCompanies = JSON.parse(JSON.stringify(this.$t('insuranceCompanies')));
    Object.keys(insuranceCompanies).forEach((element) => this.countries.push(JSON.parse(JSON.stringify({ key: element, value: insuranceCompanies[element] }))));

    /*     for (let key in insuranceCompanies) {
          // if (insuranceCompanies.hasOwnProperty(key)) {
          if (Object.hasOwn(insuranceCompanies, 'key')) {
            this.insuranceCompanies.push({
              key: key,
              value: insuranceCompanies[key],
            });
          }
        } */

    this.$store
      .dispatch('fetchHistory')
      .then((querySnapshot) => {
        let historyArray = [];
        querySnapshot.forEach((doc) => {
          let h = doc.data();
          // eslint-disable-next-line no-console
          console.log(JSON.stringify(this.insuranceCompanies));
          h.insuranceCompany = this.insuranceCompanies.find((obj) => {
            return obj.key === doc.data().insComp;
          }).value;
          h.id = doc.id;
          h.createdOnFormatted = moment(
            doc.data().createdOn.seconds * 1000
          ).format('DD/MM/YYYY');
          historyArray.push(h);
        });
        this.history = historyArray;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.log(error);
        this.error = new Error('Erreur: ' + error);
      })
      .finally(() => {
        this.isLoading = false;
      });

    setTimeout(() => {
      this.isDelayElapsed = true;
    }, 350);
  },
};
</script>

<style></style>
